import { useEffect, useRef } from 'react';

const About = () => {
  const parallaxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current && window.innerWidth >= 768) {
        const scrolled = window.scrollY;
        const element = parallaxRef.current;

        // Simple parallax effect - move in opposite direction at half speed
        const offset = scrolled * -0.5; // Move up as user scrolls down
        element.style.transform = `translateY(${offset}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative px-4 mx-auto sm:px-6 max-w-7xl overflow-hidden">
      {/* Large background SVG extending behind text */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <img
          className="absolute -top-32 -left-32 w-[500px] h-[500px] lg:w-[800px] lg:h-[800px] opacity-15"
          src="/images/circle-design.svg"
          alt="Decorative circles"
        />
      </div>

      <div className="relative grid items-center grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 lg:mt-16 lg:mb-16 relative z-10">
          <p className="text-lg leading-relaxed text-gray-800 mb-6">
            Stel je voor: je wordt wakker in de ochtend en je merkt een spanning. Je partner lijkt
            verder van je af te staan, de communicatie met je kinderen is stroef. Je vraagt je af
            hoe het komt dat je je zo alleen voelt en waarom de verbinding binnen je gezin niet is
            wat je hoopt.
          </p>
          <p className="text-lg leading-relaxed text-gray-800 mb-6">
            Misschien wil je beter begrijpen wat er gebeurt in jezelf en bij de ander, hoe het komt
            dat je in die ene situatie of door die ene persoon zo geraakt wordt, terwijl het je de
            andere keer minder raakt. Deze gevoelens en situaties zijn herkenbaar voor veel mensen.
          </p>
          <p className="text-lg leading-relaxed text-gray-800 mb-6">
            Mijn naam is Iselda Waasdijk, en ik ben een ervaren systeemtherapeut, midden in de bloei
            van het ouderschap met drie kinderen. Sinds 2022 ben ik gestart met mijn eigen praktijk
            als erkend en vrijgevestigd systeemtherapeut. Mijn passie voor het vak wordt gevoed door
            mijn enthousiasme, ambitie, leergierigheid en analytisch vermogen. Door mijn diverse
            achtergrond, zowel in mijn culturele roots als in mijn opleidingstraject, kan ik
            waardevolle inzichten bieden die voortkomen uit verschillende perspectieven. Dit stelt
            me in staat om mensen met uiteenlopende achtergronden en ervaringen beter te begrijpen
            en te ondersteunen in hun zoektocht naar verbinding en groei.
          </p>

          <p className="text-lg leading-relaxed text-gray-800">
            Met mijn ervaring in de GGZ bij verschillende instellingen weet ik dat het betrekken
            van, en werken met, het systeem essentieel is om klachten te verminderen en
            interactiepatronen te veranderen. Daarom is dit ook de focus binnen mijn praktijk en
            manier van werken. De visie waarmee ik werk vanuit mijn praktijk ligt verankerd in de
            systeemtherapie en EFT. Emotionally Focused Therapy (EFT) helpt je de onderliggende
            emoties en patronen te begrijpen die impact hebben op jou en je gezin. Of je nu iets
            mist in de communicatie, verbinding zoekt met je partner, of worstelt met je rol als
            ouder, samen kijken we naar de interactiepatronen die jullie samen vormen. We zetten de
            stap naar een omgeving waar iedereen zich gehoord, gezien en gesteund voelt. Samen
            werken we aan het herstel van verbinding en groei, voor jou, je relatie en je gezin.
          </p>
        </div>

        <div className="relative lg:col-span-1 hidden md:block">
          <div ref={parallaxRef} className="relative">
            <img
              className="relative w-full max-w-sm mx-auto lg:max-w-full"
              src="/images/circle-design.svg"
              alt="Decorative circles design"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
